import { AppInsights } from 'applicationinsights-js';

import includeAdditionalProperties from '../includeAdditionalProperties';
import ICustomTelemetryHandler from './ICustomTelemetryHandler';
import IEnvelope = Microsoft.ApplicationInsights.IEnvelope;

class TraceReactHydrationErrorAsWarningHandler implements ICustomTelemetryHandler {
  public tryHandle(envelope: IEnvelope) {
    if (envelope.data.baseType !== 'ExceptionData') {
      return false;
    }

    const { baseData } = envelope.data;
    const hydrationErrorPattern = /^Minified React error #(418|423|425)/;
    const error = baseData.exceptions.find(
      (e: { typeName: string; message: string }) => e.typeName === 'Error' && hydrationErrorPattern.test(e.message),
    );

    if (!error) {
      return false;
    }

    AppInsights.trackTrace(error.message, includeAdditionalProperties(baseData.properties), AI.SeverityLevel.Warning);

    return true;
  }
}

export default TraceReactHydrationErrorAsWarningHandler;
